import { BugIcon, EpicIcon, TaskIconMain, UserStoryIcon } from "@dit/core-frontend"

export const taskTypeIconsBySlug = {
  epic: EpicIcon,
  user_story: UserStoryIcon,
  task: TaskIconMain,
  subtask: TaskIconMain,
  bug: BugIcon,
}
